import { inject, Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/modules/authentication/services/auth.service";

@Injectable({ providedIn: 'root' })
export class InactivityService {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly ngZone = inject(NgZone);
  private inactivityTimeout!: ReturnType<typeof setTimeout>;
  private readonly limit = 2 * 60 * 60 * 1000;



  init() {
    this.resetTimer();
    this.setupListeners();
  }

  private setupListeners() {
    const events = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach(evt =>
      window.addEventListener(evt, () => this.resetTimer())
    );
  }

  private resetTimer() {
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
    }
    this.ngZone.runOutsideAngular(() => {
      this.inactivityTimeout = setTimeout(() => {
        this.ngZone.run(() => this.logout());
      }, this.limit);
    });
  }

  private logout() {
    this.authService.signOut().subscribe({
      next: () => { this.router.navigateByUrl('/login'); },
      error: () => { this.router.navigateByUrl('/login'); }
    });
  }
}